module.exports = __webpack_public_path__ + "blue-c17ad77a9ba2cf0a49a5e7fb17ff19a9.png";